<script setup lang="ts">
import { Toasts } from '@laravel-inertia-toast/vue';
import PublicFooter from '@/layouts/public/PublicFooter.vue';
import PublicNav from '@/layouts/public/PublicNav.vue';
</script>

<template>
    <div class="flex min-h-screen flex-col bg-background">
        <PublicNav />
        <main class="flex-1">
            <slot />
        </main>
        <PublicFooter />
        <Toasts />
    </div>
</template>
